import api from './api';

const clean = (value) => String(value ?? '').trim();

const unwrap = (response) => response?.data || {};

export const getMeetingNoteError = (
  error,
  fallback = 'Unable to update meeting notes.'
) =>
  clean(
    error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.message
  ) || fallback;

export const listMeetingNotes = async ({ roomId = '' } = {}) => {
  const response = await api.get('/meeting-notes', {
    params: clean(roomId) ? { roomId: clean(roomId) } : {},
  });
  const data = unwrap(response);
  return Array.isArray(data.notes) ? data.notes : [];
};

const buildPayload = ({
  roomId = '',
  roomTitle = '',
  title = '',
  subtitle = '',
  content = '',
} = {}) => ({
  roomId: clean(roomId),
  roomTitle: clean(roomTitle),
  title: clean(title),
  subtitle: clean(subtitle),
  content: clean(content),
});

export const createMeetingNote = async (values = {}) => {
  const response = await api.post('/meeting-notes', buildPayload(values));
  return unwrap(response).note;
};

export const updateMeetingNote = async (noteId, values = {}) => {
  const cleanId = clean(noteId);
  if (!cleanId) throw new Error('Meeting note ID is required.');
  const response = await api.patch(
    `/meeting-notes/${encodeURIComponent(cleanId)}`,
    buildPayload(values)
  );
  return unwrap(response).note;
};

export const deleteMeetingNote = async (noteId) => {
  const cleanId = clean(noteId);
  if (!cleanId) throw new Error('Meeting note ID is required.');
  const response = await api.delete(
    `/meeting-notes/${encodeURIComponent(cleanId)}`
  );
  return unwrap(response);
};
